import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { Typography as AntdTypography } from 'antd';
import type { LinkProps } from 'antd/es/typography/Link';
import type { ParagraphProps } from 'antd/es/typography/Paragraph';
import styled, { css } from 'styled-components';

import type { CustomTextProps, CustomTitleProps } from './types';

const levelToSizeKey: Record<NonNullable<CustomTitleProps['level']>, (typeof SIZES)[keyof typeof SIZES]> = {
    1: SIZES.HEADING_XL,
    2: SIZES.HEADING_LG,
    3: SIZES.HEADING_MD,
    4: SIZES.HEADING_SM,
    5: SIZES.HEADING_XS,
    6: SIZES.HEADING_XXS,
};

export const BaseTitle = styled(AntdTypography.Title)<CustomTitleProps>`
    ${FONT_FAMILY.poppins};

    ${({ level = 1 }) => {
        const sizeKey = levelToSizeKey[level] ?? SIZES.HEADING_XL;
        const { fontSize, lineHeight, fontWeight } = DESKTOP_SIZES[sizeKey];

        return css`
            ${fontSize};
            ${lineHeight};
            ${fontWeight};
        `;
    }}
`;

export const BaseText = styled(AntdTypography.Text)<CustomTextProps>`
    ${({ size }) => css`
        ${DESKTOP_SIZES[size].fontSize}
        ${DESKTOP_SIZES[size].lineHeight}
        ${DESKTOP_SIZES[size].fontWeight}
    `}
`;

export const BaseParagraph = styled(AntdTypography.Paragraph)<ParagraphProps>`
    /* Add paragraph-specific styles here */
`;
export const BaseLink = styled(AntdTypography.Link)<LinkProps>`
    /* Add paragraph-specific styles here */
`;
